import {useMutation} from "@tanstack/react-query";
import {useModal} from "../../../../hooks";
import {verifySerialNumber} from "../../../../api/support/RMA";
import {AxiosError} from "axios";
import {RmaDetailItemType} from "../../../../types/support";
import VerifyRmaSerialNoInner from "../../../../components/common/modal/inner/VerifyRmaSerialNoInner";

const useVerifySerialNumber = () => {
    const {handleModal} = useModal();

    const {mutate} = useMutation({
        mutationFn: (data: RmaDetailItemType[]) => verifySerialNumber(data),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: <VerifyRmaSerialNoInner
                        data={res.data.result ?? {outgoingManagementVOList: [], failSerialCodeList: []}}
                        modalDepth={1}
                    />,
                    type: "",
                    modalSize: "lg",
                    className: "w_980"
                });
            } else {
                handleModal({
                    isOpen: true,
                    contents: res.data.msg,
                    type: "alert",
                });
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });
    return {mutate};
};

export default useVerifySerialNumber;
